import { useRouteError } from 'react-router';
import { ErrorState } from '@/components/ui';

/** Last-resort boundary for render/loader errors in a route. */
export function RouteErrorPage() {
  const error = useRouteError();
  return <ErrorState error={error} onRetry={() => window.location.reload()} />;
}
